<div class="loader-container">
    <app-loader *ngIf="loading"></app-loader>
    <app-modal-header *ngIf="modalStyle" [title]="modalTitle"></app-modal-header>
    <div [ngClass]="{ 'modal-body': modalStyle }">
        <div *ngIf="errorMessage" class="alert alert-danger d-flex align-items-center" role="alert">
            <div>{{ errorMessage }}</div>
        </div>

        <div *ngIf="currentStep === 1" class="row">
            <app-order-organisation-form [item]="item"></app-order-organisation-form>
        </div>

        <div *ngIf="currentStep === 2" class="row">
            <app-order-invoice-form [item]="item"></app-order-invoice-form>
        </div>

        <div class="form-buttons">
            <button *ngIf="currentStep > 1" type="button" class="btn btn-secondary" (click)="goToPreviousStep()">
                Terug
            </button>
            <button type="button" class="btn btn-primary" (click)="goToNextStep()">
                {{ currentStep === 1 ? 'Volgende' : 'Bestelling aanmaken' }}
            </button>
        </div>
    </div>
</div>